import apiAgent from "@/app/api/apiAgent";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/app/common/common-components/ui/Select";
import { useQuery } from "@tanstack/react-query";

type PipelineDropdownProps = {
  type: "deal" | "contact";
  officeId: string;
  pipeLineId: string;
  onPipeLineIdChange: (pipeLineId: string) => void;
  disabled?: boolean;
  placeholder?: string;
};

const PipelineDropdown = ({ type, officeId, pipeLineId, onPipeLineIdChange, disabled, placeholder }: PipelineDropdownProps) => {
  const { data: pipelines, isLoading } = useQuery({
    queryKey: ["pipelines-dropdown", officeId],
    queryFn: () => apiAgent.Pipeline.getPipelines(type, officeId),
  });

  const isDisabled = !pipelines || pipelines.length === 0 || isLoading || disabled;

  return (
    <Select value={pipeLineId} onValueChange={(value) => !isDisabled && onPipeLineIdChange(value)} disabled={isDisabled}>
      <SelectTrigger disabled={isDisabled}>
        <SelectValue placeholder={placeholder || "Select pipeline"} />
      </SelectTrigger>
      <SelectContent>
        {pipelines?.map((pipeline) => (
          <SelectItem key={pipeline.pipeline_id} value={pipeline.pipeline_id}>
            {pipeline.pipeline_name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default PipelineDropdown;
